"use client"

import Link from "next/link"
import { useSession } from "next-auth/react"
import { SignInButton } from "./sub-menu"

export default function Header() {
  const { data: session } = useSession()

  return (
    <header className="z-40 block print:hidden bg-[rgb(0_61_96)] text-white">
      <nav>
        <section className="mx-auto flex h-[60px] min-h-full w-full max-w-6xl items-center justify-between px-3 sm:px-4 xl:px-0">
          <Link
            id="rtbf-logo"
            aria-label="RTBF Actus - Accueil"
            className="flex items-center h-full !outline-offset-[-4px] hover:opacity-90 focus:outline focus:outline-4 focus:outline-offset-2 focus:outline-white/70"
            href="/"
          >
            <img
              src="https://ocnc-fantasy.s3.eu-west-1.amazonaws.com/files/cdm26_le_jeu_logo.svg"
              alt="CDM26 Le Jeu"
              className="h-9 w-auto"
            />
          </Link>

          <div className="flex items-center gap-x-6">
            {session?.user?.username && (
              <span className="hidden sm:inline text-sm font-bold tracking-wide">
                Bonjour {session.user.username}
              </span>
            )}
            <SignInButton />
          </div>
        </section>
      </nav>
    </header>
  )
}
